<h1 mat-dialog-title>{{ data.type }}</h1>
<div mat-dialog-content>{{ data.message }}</div>
<div style="float: right;" mat-dialog-actions>
  <button mat-raised-button *ngIf="data.buttonConfirm" value="Confirm"  mat-dialog-confirm class="alert-button" [mat-dialog-close]="true" style="margin-right:5px;">{{ data.buttonConfirm }}</button>
  <button mat-raised-button value="Close" class="alert-button" [mat-dialog-close]="false">{{ data.buttonCancel }}</button>
</div>
